module.exports = __webpack_public_path__ + "static/media/SCBlowBat.01476301.svg";